module.exports = __webpack_public_path__ + "img/edge_activites_groupes.64106619.svg";